import axios from "axios";
import config from "shared/config/env";

const TIME_OUT = 180000;

export default axios.create({
  baseURL: config.baseUrl,
  timeout: TIME_OUT,
  headers: {
    "Content-Type": "application/json;utf-8",
    "Access-Control-Allow-Origin": "*",
  },
});
